export default __webpack_public_path__ + "static/media/mice_04.06724128.png";